import React from 'react';
import { observer } from 'mobx-react-lite';
import FileChip from './FileChip';
import chatStore from '../stores/chatStore';

const AttachmentBar = observer(() => {
    if (!chatStore.attachments.length) return null;
    return (
        <div className="mb-2 flex flex-wrap gap-2 px-1">
            {chatStore.attachments.map((item) => (
                <FileChip key={item.localId} item={item} />
            ))}
        </div>
    );
});

export default AttachmentBar;
